import { useState } from 'react'
import { useHistory } from 'react-router'
import { useAsync } from 'react-use'
import { Col, Row, Space, Typography } from 'antd'
import classNames from 'classnames'

import Page from 'components/Page'
import Card from 'components/Card'
import Button from 'components/Button'
import Table from 'components/Table'
import AllActiveInactive from 'components/AllActiveInactive'

import { useTranslate } from 'hooks/translate'

import { getReportHeaderTypeApi } from 'services/report_header_attr'

import Styled from './styled'

export default function PageReportHeaderAttribute () {
  const { t } = useTranslate()
  const history = useHistory()

  const [dataSource, setDataSource] = useState([])
  const [filters, setFilters] = useState({
    param: null,
    is_active: null,
  })
  const [status, setStatus] = useState('all') // all, active, inactive
  const [isLoading, setIsLoading] = useState(false)

  const getReportHeaderType = async () => {
    if (isLoading) return

    const params = {
      ...filters,
    }

    if (status !== 'all') {
      params.is_active = status === 'active'
    }

    setIsLoading(true)

    const res = await getReportHeaderTypeApi(params)

    setIsLoading(false)

    setDataSource(res.data)
  }

  useAsync(async () => {
    getReportHeaderType()
  }, [status, filters])

  const columns = [
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
      className: 'bold',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: t('Description'),
      dataIndex: 'description',
      key: 'description',
      sorter: (a, b) => a.description.localeCompare(b.description),
    },
    {
      title: t('Status'),
      dataIndex: ['status', 'label'],
      key: 'status',
      className: 'is-status',
      sorter: (a, b) => a.status.label.localeCompare(b.status.label),
      render: (text, record) => {
        return (
          <div
            className={classNames('status-block', {
              'is-active': record.isEnabled,
              'is-inactive': !record.isEnabled,
            })}
          >
            <Typography.Text>{text}</Typography.Text>
          </div>
        )
      },
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: 150,
      align: 'center',
      render: (text, record, index) => {
        return (
          <div>
            <Button
              type='primary'
              onClick={() => {
                history.push(`${history.location.pathname}/${record.id}`)
              }}
            >
              {t('Setup')}
            </Button>
          </div>
        )
      },
    },
  ]

  return (
    <Styled className='page page-report-header-attribute'>
      <Page
        title={t('Report Header Attribute')}
        searchPlaceholder={t('Search Report Header Name or Description')}
        onSearch={(value) => {
          setFilters({
            ...filters,
            param: value,
          })
        }}
      >
        <Space size='middle' direction='vertical' style={{ width: '100%' }}>
          <Row justify='space-between'>
            <Col>
              <Button type='primary' size='large'></Button>
            </Col>
          </Row>
          <Card title={t('Report Header Attribute')}>
            <Row justify='end'>
              <Col xs={24} sm={8} lg={4}>
                <AllActiveInactive value={status} onChange={(value) => setStatus(value)} />
              </Col>
            </Row>
            <Table
              loading={isLoading}
              columns={columns}
              dataSource={dataSource}
              scroll={{ x: 800 }}
              pagination={false}
              sticky
            />
          </Card>
        </Space>
      </Page>
    </Styled>
  )
}
